export default "__VITE_ASSET__BulmVGEk__"